export default __webpack_public_path__ + "static/10_9-4ed631b8538805cbc2c90f15cf57eff6.png";